<template>
  <a-spin :spinning="!this.chartData">
    <h3 align="center">Health and pension expenditure of population aging countries</h3>
    <svg id="health-pension-chart"></svg>
    <svg id="legend" width="550" height="40"></svg>
    <div class="commands">
        <span class="filter_c" id="Japan" style="background-color: #67000d">Japan</span>
        <span class="filter_c" id="Italy" style="background-color: #67000d">Italy</span>
        <span class="filter_c" id="Finland" style="background-color: #67000d">Finland</span>
        <span class="filter_c" id="France" style="background-color: #67000d">France</span>
        <span class="filter_c" id="Spain" style="background-color: #67000d">Spain</span>
        <span class="filter_c" id="UK" style="background-color: #a50f15">United Kingdom</span>
        <span class="filter_c" id="Canada" style="background-color: #a50f15">Canada</span>
    </div>
    <div class="commands">
        <span class="filter_c" id="USA" style="background-color: #cb181d">United States</span>
        <span class="filter_c" id="Australia" style="background-color: #cb181d">Australia</span>
        <span class="filter_c" id="Iceland" style="background-color: #cb181d">Iceland</span>
        <span class="filter_c" id="China" style="background-color: #fb6a4a">China</span>
        <span class="filter_c" id="Chile" style="background-color: #fb6a4a">Chile</span>
        <span class="filter_c" id="Turkey" style="background-color: #fc9272">Turkey</span>
        <span class="filter_c" id="Mexico" style="background-color: #fcbba1">Mexico</span>
    </div>
  </a-spin>
</template>

<script>
import * as d3 from "d3";
import axios from "axios";
export default {
    name: "HealthPensionChart",
    data: function(){
        return{
            chartData: null,
        };
    },
    mounted(){
   const API = this.$store.state.API;
    if (!this.$store.state.HPAData) {
      axios.get(`${API}affect/medical_pension_aging.json`).then(result => {
        this.chartData = result.data;  
        this.$store.commit('HPAData', result.data);
        this.makeHealthPensionChart();
        })
    } else {
      this.chartData = this.$store.state.HPAData;
      this.makeHealthPensionChart();
    }},
    methods:{
        makeHealthPensionChart(){
            
            var dataset = this.chartData;
            var years = dataset.years;
            var countries = dataset.countries;
            
            var margin = { top: 20, left: 40, bottom: 50, right: 50 },
				width = 670 - margin.left - margin.right,
				height = 450 - margin.top - margin.bottom;
            var svg = d3.select('#health-pension-chart')
				// .append('svg')
				.attr('width', width + margin.left + margin.right)
				.attr('height', height + margin.top + margin.bottom)
                .append('g')
                .style('background-color', 'white')
                .attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');
            var legend = d3.select('#legend');
            
			var x = d3.scaleBand();
            var y = d3.scaleLinear();
            var y2 = d3.scaleLinear();           
            var color = {"Japan":	"#67000d",
                        "Italy":	"#67000d",
                        "Finland":	"#67000d",
                        "France":	"#67000d",
                        "Spain":	"#67000d",
                        "United Kingdom":	"#a50f15",
                        "Canada":	"#a50f15",
                        "United States":	"#cb181d",
                        "Australia":	"#cb181d",
                        "Iceland":	"#cb181d",
                        "China":	"#fb6a4a",
                        "Chile":	"#fb6a4a",
                        "Turkey":	"#fc9272",
                        "Mexico":	"#fcbba1"}

            var delay = function (d, i) {
				return i * 50;
			};

            // var dataset;
            var current = dataset['Japan'];
            var current_country = 'Japan';
            var xAxis;
            var line = d3.line()  // 🚧 what is line?
                            .x(function(d) {
                            return x(d.year);
                            })
                            .y(function(d) {
                                // console.log(d.ap)
                            return y2(+d.ap);
                            });
            
            draw();
            toggle('#Japan');
            
            
            countries.forEach(country => {
                var buttonId;
                if (country == "United States") {
                    buttonId = '#USA'
                } else {
                    if (country == "United Kingdom"){
                        buttonId = '#UK'
                    }
                    else {
                        buttonId = '#' + country
                    }
                }
                d3.select(buttonId)
                    .on('click', () => {
                        
                        x.domain(years);
                        current = dataset[country];
                        current_country = country
                        // console.log(current)
                        redraw();
                        transition();
                        toggle(buttonId);
                    });
            });
            
            function transition() {
				var transition = svg.transition()
                    .duration(750);

                transition
                    .selectAll("rect")
                    .delay(delay)
                    .attr('x', d => x(d.year));

                transition
                    .select("#x-axis")
                    .call(xAxis);
            }
            
            function toggle(id) {
                countries.forEach(country => {
                var buttonId;
                if (country == "United States") {
                    buttonId = '#USA'
                } else {
                    if (country == "United Kingdom"){
                        buttonId = '#UK'
                    }
                    else {
                        buttonId = '#' + country
                    }
                }
                    d3.selectAll(buttonId)
					.style('background-color', color[country]);
                });
				
				d3.select(id)
					.style('background-color', 'lightblue');
            }

            function draw() {
                x.domain(years)
					.range([0, width])
                    .paddingInner(0.2);

                y.domain([3, 28])
                    .range([height, 0]);

                y2.domain([5, 30])
                    .range([height, 0]);
                    
                svg.selectAll('rect')
					.data(current, d => d.year)
					.enter()
					.append('rect')
					.attr('class', 'bar')
					.attr('x', d => x(d.year))
					.attr('y', d => y(+d.mp))
					.attr('width', x.bandwidth())
                    .attr('height', d => height - y(+d.mp));

                svg.selectAll('.mp')
                    .data(current, d => d.year)
                    .enter()
                    .append('text')
                    .text(d => +d.mp)
                    .style('font-size', '0.7em')
                    .attr('class', 'mp')
                    .attr('x', d => x(d.year) + x.bandwidth() / 2)
                    .attr('y', d => y(+d.mp) + (height - y(+d.mp)) * 6 / 7);
                
                //var g = svg.append('g').attr('transform', 'translate('+ x.bandwidth()/2 + ', ' + margin.top + ')');
                

                svg.append('path')
                    .attr('class', 'line')
                    .datum(current)  // 🚧 try using data(data) and explain the difference below
                    .attr('fill', 'none')
                    .attr('stroke', color[current_country])
                    .attr('stroke-linejoin', 'round')
                    .attr('stroke-linecap', 'round')
                    .attr('stroke-width', 1.5)
                    .attr('transform', 'translate('+ x.bandwidth()/2 + ', 0)')
                    .attr('d', line);

                svg.selectAll("circle")
                    .data(current)
                    .enter()
                    .append("circle")
                    .attr("r", 3)
                    .attr("cx", function(d) { return x.bandwidth()/2+x(d.year); })
                    .attr("cy", function(d) { return y2(+d.ap); })
                    .style("fill", function() { return color[current_country]; })
                    .append("title")
                    .text(d => d.ap);
                
                xAxis = d3.axisBottom()
                    .scale(x);
                    
                svg.append('g')
					.attr('id', 'x-axis')
					.attr('class', 'axis')
					.attr('transform', 'translate(0,' + height + ')')
                    .call(xAxis);
                    
                var yAxis = d3.axisLeft()
					.scale(y)
                    .ticks(5, 'd');

                var y2Axis = d3.axisRight()
					.scale(y2)
                    .ticks(5, 'd');
                    
                svg.append('g')
					.attr('class', 'axis')
                    .call(yAxis);
                
                svg.append('g')
                    .attr('class', 'axis')
                    .attr('transform', 'translate('+ width + ', 0)')
                    .call(y2Axis);
                    
                svg.append('text')
					.attr('x', - height / 2)
					.attr('y', - margin.left * 0.6)
					.attr('transform', 'rotate(-90)')
					.attr('class', 'label')
					.append('tspan').text('Health and Pention Spending (% of GDP)')
					.style('baseline-shift', 'super')
                    .style('font-size', '0.8em');

                svg.append('text')
					.attr('x',  height / 2)
					.attr('y', -margin.right * 12.1)
					.attr('transform', 'rotate(90)')
					.attr('class', 'label')
					.append('tspan').text('Population ages 65+ (% of total population)')
					.style('baseline-shift', 'super')
                    .style('font-size', '0.8em');
                    
                
                legend.append('rect')
                    .attr('width', x.bandwidth())
                    .attr('height', 10)
                    .attr('fill', '#add8e677');
                legend.append('text')
                    .attr('x', x.bandwidth() + 2)
                    .attr('y', 9)
                    .text('Health and Pention Spending (% of GDP)')
                    .style('font-size', '0.7em');
                legend.append('rect')
                    .attr('class', 'aplegend')
                    .attr('x', 8.5 * x.bandwidth() + 8)
                    .attr('y', 4)
                    .attr('width', x.bandwidth())
                    .attr('height', 1.5)
                    .attr('fill', color[current_country]);
                legend.append('circle')
                    .attr('class', 'aplegend')
                    .attr('cx', 9 * x.bandwidth() + 8)
                    .attr('cy', 4.5)
                    .attr('r', 3)
                    .attr('fill', color[current_country]);
                legend.append('text')
                    .attr('x', 9.5 * x.bandwidth() + 10)
                    .attr('y', 9)
                    .text('Population ages 65+ (% of total population)')
                    .style('font-size', '0.7em');
                    
            }

            function redraw() {

                svg.selectAll('rect')
                    .remove()

                svg.selectAll('.mp')
                    .remove()

                svg.selectAll('.line')
                    .remove()
                
                svg.selectAll('circle')
                    .remove()

                

                svg.selectAll('rect')
					.data(current, d => d.year)
					.enter()
					.append('rect')
					.attr('class', 'bar')
					.attr('x', d => x(d.year))
					.attr('y', d => y(+d.mp))
					.attr('width', x.bandwidth())
                    .attr('height', d => height - y(+d.mp));

                svg.selectAll('.mp')
                    .data(current, d => d.year)
                    .enter()
                    .append('text')
                    .text(d => +d.mp)
                    .style('font-size', '0.7em')
                    .attr('class', 'mp')
                    .attr('x', d => x(d.year) + x.bandwidth() / 2)
                    .attr('y', d => y(+d.mp) + (height - y(+d.mp)) * 6 / 7);

                svg.append('path')
                    .attr('class', 'line')
                    .datum(current)  // 🚧 try using data(data) and explain the difference below
                    .attr('fill', 'none')
                    .attr('stroke', color[current_country])
                    .attr('stroke-linejoin', 'round')
                    .attr('stroke-linecap', 'round')
                    .attr('stroke-width', 1.5)
                    .attr('transform', 'translate('+ x.bandwidth()/2 + ', 0)')
                    .attr('d', line);

                svg.selectAll("circle")
                    .data(current)
                    .enter()
                    .append("circle")
                    .attr("r", 3)
                    .attr("cx", function(d) { return x.bandwidth()/2+x(d.year); })
                    .attr("cy", function(d) { return y2(+d.ap); })
                    .style("fill", function() { return color[current_country]; })
                    .append("title")
                    .text(d => d.ap);
                    
                legend.selectAll(".aplegend")
                .style('fill', color[current_country]);
                
            }
            

        }
    }
}
</script>

<style scoped>

>>> text.mp {
    font-weight: bold;
    text-anchor: middle;
    alignment-baseline: central;
}

>>> .bar {
    fill: #add8e677;
}

>>> .axis path,
>>> .axis line {
    fill: none;
    stroke: black;
    shape-rendering: crispEdges;
}

>>> .axis text {
    font-family: Courier;
    font-size: 12px;
}

>>> text {
    font-family: Courier;
    font-size: 0.85em;
}

>>> text.label {
    text-anchor: middle;
    alignment-baseline: central;
}

>>> .filter_c {
    border-radius: 3px;
    /* background-color: rgb(129, 128, 128); */
    padding: 5px;
    margin: 5px;
    color: #fff;
    display: inline-block;
    cursor: default;
}

>>> div.commands {
    font-family: Courier;
    font-size: 0.85em;
    font-weight: bold;
    text-align: center;
    cursor: default;
    user-select: none;
}

>>> svg {
    display: block;
    margin: auto;
    background-color: #fff;
}
</style>

